import { createStyles, makeStyles } from "@material-ui/core";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { IBranchRequest } from "../../models/branch.model";
import { ColumnModel } from "../../models/common.model";
import ModalCancel from "../modals/ModalCancel";

const useStyles = makeStyles((theme) =>
  createStyles({
    select: {
      "&.Mui-selected": {
        backgroundColor: muiSelected,
      },
    },
  })
);
let muiSelected: any;
const columns: readonly ColumnModel[] = [];
interface props {
  columns: any;
  data: IBranchRequest[];
  pageInfo: any;
  handleChangePagination: any;
  handleDeleteBranch: Function;
  handleEditBranch: Function;
}
export default function TableCreator({
  columns,
  data,
  pageInfo,
  handleChangePagination,
  currentPaginationInfo,
  pathname,
  handleDeleteBranch,
  handleEditBranch,
}: any) {
  const [openModalCancelBranch, setOpenModalCancelBranch] = useState<boolean>(
    false
  );
  const [branchId, setBranchId] = useState<number>();

  const history = useHistory<{
    from: string;
    id: string;
    pageNumber: 1;
    clickOnBack: boolean;
  }>();

  const handelDetail = (
    requestId: string,
    loanRequestStatus: string,
    registrationRequestId: number,
    rowIndex: number
  ) => {
    // handleSelectRow(rowIndex);
    history.push({
      pathname: pathname,
      state: {
        id: requestId,
        from: "",
        // pageNumber: currentPaginationInfo.pageNumber!,
        pageNumber: 1,
        clickOnBack: false,
      },
    });
  };
  const classes = useStyles();
  const nextIcon = () => {
    return (
      <img style={{ height: "12px", width: "10px" }} src="images/Next.png" />
    );
  };
  const previusIcon = () => {
    return (
      <img
        style={{ height: "12px", width: "10px" }}
        src="images/Previous.png"
      />
    );
  };

  const handleDeleteBranchWithModal = () => {
    handleDeleteBranch(branchId);
  };
  const jsonFile = useSelector((state: any) => state.style);
  muiSelected = jsonFile?.muiSelected;
  return (
    <div>
      <div className="cardTableBorder ">
        <TableContainer
          style={{ background: "#fff", direction: "rtl" }}
          // className="boxScroll"
        >
          <Table
            stickyHeader
            aria-label="sticky table "
            style={{ borderCollapse: "collapse" }}
          >
            <TableHead className="rowTHead" style={{ paddingBottom: "10px" }}>
              <TableRow
                classes={{ root: classes.select }}
                className={`${classes} borderRight borderLeft`}
                // selected={selectedRow === 0}
              >
                <TableCell
                  className="rowTHead colorTitle textFont12 fontWeight"
                  align="right"
                  style={{ width: "5px" }}
                >
                  #
                </TableCell>
                {columns.map((column: any) => (
                  <TableCell
                    className="rowTHead colorTitle textFont12 fontWeight nowrapClass"
                    key={column.id}
                    align="right"
                  >
                    {column.label}
                  </TableCell>
                ))}
                <TableCell
                  className="rowTHead colorTitle textFont12 fontWeight"
                  align="right"
                  style={{ width: "10vh", minWidth: "10vh" }}
                >
                  آدرس
                </TableCell>
                <TableCell
                  className="rowTHead colorTitle textFont12 fontWeight"
                  align="right"
                  style={{ width: "10vh", minWidth: "10vh" }}
                >
                  <MoreHorizIcon />
                </TableCell>
              </TableRow>
            </TableHead>
            <div style={{ width: "100%", height: "10px" }}></div>
            <TableBody>
              {data?.map((row: any, rowIndex: number) => {
                return (
                  <TableRow
                    classes={{ root: classes.select }}
                    className={`${
                      rowIndex % 2 == 0
                        ? "rowTBodyE  borderRight borderLeft"
                        : "rowTBodyO  borderRight borderLeft"
                    }${classes} borderRight borderLeft  noWrap`}
                    hover
                    role="checkbox"
                    tabIndex={-1}
                    key={row.id}
                    // selected={selectedRow === rowIndex}
                    onClick={() => {}}
                  >
                    <TableCell className="textFont12" style={{ width: "5px" }}>
                      {(0 - 1) * 0 + rowIndex + 1}
                    </TableCell>
                    {columns.map((column: any) => {
                      const value = row[column.id as keyof any];
                      return (
                        <TableCell
                          className="textFont12 nowrapClass"
                          key={column.id}
                          align="right"
                        >
                          {column.format && column.hasFormat ? (
                            column.format(value)
                          ) : column.id === "isActive" ? (
                            value === true ? (
                              <b style={{ color: "#28A745" }}>فعال</b>
                            ) : (
                              <b style={{ color: "#E6123D" }}>غیرفعال</b>
                            )
                          ) : (
                            value
                          )}
                        </TableCell>
                      );
                    })}
                    <TableCell className="textFont12 nowrapClass" align="right">
                      {row.address || row.url}
                    </TableCell>
                    <TableCell
                      sx={{
                        display: "flex",
                        gap: "5px",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      align="center"
                      component="th"
                      scope="row"
                      className={
                        rowIndex % 2 == 0
                          ? " stickyColOLeft   "
                          : " stickyColELeft  "
                      }
                    >
                      <EditOutlinedIcon
                        sx={{
                          color: "#1D4A87",
                          fontSize: "1.8rem",
                          cursor: "pointer",
                        }}
                        onClick={(e) => {
                          // e.stopPropagation();
                          handleEditBranch(row.id);
                        }}
                      />
                      <DeleteOutlineIcon
                        sx={{
                          color: "#1D4A87",
                          fontSize: "1.8rem",
                          cursor: "pointer",
                        }}
                        onClick={(e) => {
                          // e.stopPropagation();
                          setOpenModalCancelBranch(true);
                          setBranchId(row.id);
                        }}
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <ModalCancel
        title={""}
        bgColor={"kamanColor"}
        setValue={handleDeleteBranchWithModal}
        openModal={openModalCancelBranch}
        setOpenModal={setOpenModalCancelBranch}
      />
    </div>
  );
}
